<template>
    <div class="main-data-statistics-group" v-loading="loading">
        <div class="statistics-item-group" v-for="(i,k) in statisticsData" :key="k">
            <div class="statistics-tit-group">
                <el-tooltip class="item" effect="dark" :content="statisticsKey[k]+''" placement="top">
                    <span>{{statisticsKey[k]}}</span>
                 </el-tooltip>
             </div>
             <div class="statistics-num-group">
                 <el-tooltip class="item" effect="dark" :content="i[statisticsKey[k]]+''" placement="top">
                     <span>{{i[statisticsKey[k]]}}</span>
                 </el-tooltip>
             </div>
        </div>
    </div>
</template>

<script>
import { isEmpty } from 'lodash';
import {getFormFieldStatisticsGroup} from '@/data-model';
export default{
    components: {

    },
    props: {
        fieldConfig: {
            type: Object
        },
        cacheDataId: {
            type: String,
            default: ''
        },
        isDesign: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            statisticsData: [],
            statisticsKey: [],
            loading: false
        };
    },
    created () {
        if (!isEmpty(this.fieldConfig)) {
            this.initStatistics();
        }
    },
    methods: {
        async initStatistics () {
            this.loading = true;
            this.fieldConfig.cacheDataId = this.cacheDataId;
            this.fieldConfig.isDesign = this.isDesign;
            let res = await getFormFieldStatisticsGroup(this.fieldConfig);
            if (res && res.state === 'success') {
                this.statisticsKey = res.dataKey;
                this.statisticsData = res.data;
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="less">
	.main-data-statistics-group{
        width: 100%;
        height: auto;
        position: relative;
        .statistics-item-group{
            margin-left: 10px;
            padding: 10px;
            height: 40px;
            line-height: 40px;
            width: 90%;
            text-align: center;
            border-radius: 6px;
            margin-top: 10px;
            cursor: pointer;
            border-bottom: 1px solid #F0F0EE;
            display: flex;
            .statistics-num-group{
                width: 110px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                font-size: 20px;
                color: #00ebeb;
                font-weight: 500;
                -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                overflow: hidden; /*超出的文本隐藏*/
                text-overflow: ellipsis; /* 溢出用省略号*/
                -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
            }
            .statistics-tit-group{
                flex: 1;
                height: 40px;
                text-align: left;
                line-height: 40px;
                font-size: 18px;
                font-weight: 600;
                -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                overflow: hidden; /*超出的文本隐藏*/
                text-overflow: ellipsis; /* 溢出用省略号*/
                -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
            }
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/StatisticsGroupPreview.vue